<template>
  <a-modal
    title="删除"
    :width="820"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-form>
      <a-form-item
        label="考勤小组"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol">
        <a-select
          showSearch
          placeholder="请选择"
          :filterOption="filterOption"
          v-model="queryParam.groupId"
          :options="attendGroupList">
        </a-select>
      </a-form-item>
      <a-form-item
        label="时间"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol">
        <a-range-picker :allowClear="false" style="width: 100%" @change="onDateChange" :value="dateRange"/>
      </a-form-item>
      <a-form-item
        label="工人类别"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol">
        <a-select
          allowClear
          showSearch
          placeholder="请选择"
          :filterOption="filterOption"
          v-model="queryParam.typeId"
          :options="workerList">
        </a-select>
      </a-form-item>
      <a-form-item
        label="请出入“删除”字样"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol">
        <a-input placeholder="请出入“删除”字样后才能点击确认" v-model="keywords"/>
      </a-form-item>
    </a-form>
    <template slot="footer" >
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :disabled="buttonDisabled" type="primary" @click="handleOk">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { FormMixin } from '@/mixins/FormMixin'
import { attendGroupList } from '@api/common/AttendGroup'
import { del } from '@api/attend/attendDaily'
import { dropSxWorkerTypeList } from '@api/common/SxWorkerType'
export default {
  name: 'CuringSubcontractAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      keywords: '',
      buttonDisabled: true,
      attendGroupList: [],
      workerList: [],
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false,
      queryParam: {
        groupId: '',
        startDate: '',
        endDate: '',
        typeId: undefined
      },
      dateRange: [moment().startOf('month'), moment().endOf('month')] // 时间范围
    }
  },
  methods: {
    edit (id, type) {
      this.dateRange = [moment().startOf('month'), moment().endOf('month')]
      this.queryParam.startDate = moment().startOf('month').format('YYYY-MM-DD')
      this.queryParam.endDate = moment().endOf('month').format('YYYY-MM-DD')
      this.buttonDisabled = true
      this.keywords = ''
      this.getAttendGroupList()
      this.getDropSxWorkerTypeList()
      this.list = []
      this.visible = true
      const { form: { resetFields } } = this
      resetFields()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onDateChange (date, string) {
      this.dateRange = date
      this.queryParam.startDate = string[0]
      this.queryParam.endDate = string[1]
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          del({ ...this.queryParam }).then(() => {
            this.$message.success('删除成功')
          }).catch(() => {
            this.$message.error('删除失败')
          })
          try {
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    },
    getAttendGroupList () {
      attendGroupList().then(res => {
        this.attendGroupList = res.data
        // 修改原因：不同权限对应的下拉选择框的第一个数据不一样，所以此处动态取值
        this.queryParam.groupId = res.data[0].value
      })
    },
    getDropSxWorkerTypeList () {
      dropSxWorkerTypeList().then(res => {
        this.workerList = res.data
        this.queryParam.typeId = res.data[0].value
      })
    }

  },
  watch: {
    keywords: {
      immediate: true,
      handler: function (newVal) {
        if (newVal === '删除') {
          this.buttonDisabled = false
        } else {
          this.buttonDisabled = true
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
